import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="cart-buttons"
export default class extends Controller {
  static targets = [
  ];

  connect() {

  }

  disconnect() {

  }

  openGreetingCardPopup(e) {
    e.preventDefault();
    this.dispatch("openGreetingCardPopup");
  }
}
